import { charMapping } from "../data/charmapping";
import { Dictionary } from "../dictionary";
export class CharacterMapping {
    /**
     * takes all data fro data/charmapping.ts and puts them in a dictionary
     */
    constructor() {
        this.dict = new Dictionary();
        charMapping.forEach(a => this.dict.put(a.id, a));
    }
    /**
     * sums up character atributes
     * @param id of attribute / group
     * @param character
     * @returns
     */
    sumCharacterAtributes(id, character) {
        const charMapping = this.dict.get(id);
        if (charMapping == undefined || charMapping.keys.length == 0)
            return 0;
        return charMapping
            .keys
            .map(k => character[k])
            .reduce((a, b) => a + b) + charMapping.defaultValue;
    }
}
